import { useOne, useParsed } from '@refinedev/core';
import type { StudyDetail } from '@aphp-ema/common/study';
import type { Question } from '@aphp-ema/common/questionnaire';

export const useInitialQuestions = (enabled: boolean = true): Question[] => {
  const { id: studyId } = useParsed();

  const result = useOne<StudyDetail>({
    resource: 'admin/studies',
    id: studyId,
    queryOptions: {
      enabled: !!studyId && enabled,
    },
  });

  const questions = result.data?.data?.initialQuestionnaire?.questions || [];

  return questions;
};
